import {
  Component,
  EventEmitter,
  OnInit,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { Router } from '@angular/router';
import { SharedService } from '../../../Services/shared.service';
import { CommonModule } from '@angular/common';
// import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class HeaderComponent implements OnInit {
  isSidenavOpen: boolean = false;
  @Output() sidenavToggle = new EventEmitter<void>();
  loginData: any;

  constructor(private router: Router, private sharedService: SharedService) {}

  ngOnInit(): void {
    this.loginData = this.sharedService.getLoginData();

    this.sharedService.loginDataUpdated.subscribe((data) => {
      this.loginData = data;
    });
  }

  toggleSidenav() {
    this.isSidenavOpen = !this.isSidenavOpen;
    this.sidenavToggle.emit();
  }

  logout(): void {
    localStorage.removeItem('jwtToken');
    this.router.navigate(['/login']);
  }

  userTypeMap: { [key: string]: string } = {
    '1': 'Individual Requester',
    '2': 'Corporate Requester',
    '3': 'Dumpster',
    '4': 'Dump Yard',
    '5': 'Admin',
    '6': 'SuperAdmin',
    '7': 'SuperExecutive',
    '8': 'SuperFinance',
    '9': 'Executive',
    '10': 'Finance',
    '11': 'Baldia',
  };

  getUserTypeName(userTypeID: string): string {
    return this.userTypeMap[userTypeID] || 'Unknown';
  }
}
